import {
	HeadingNode,
	HeadingTagType,
	SerializedHeadingNode,
} from "@lexical/rich-text";
import { $applyNodeReplacement, EditorConfig, LexicalNode } from "lexical";

export class ExtendedHeadingNode extends HeadingNode {
	readonly styleMap = {
		h1: "font-size: 24px; color: rgb(5, 5, 5); font-weight: 400; margin: 0;",
		h2: "font-size: 15px; color: rgb(5, 5, 5); font-weight: 700; margin: 0;",
		h3: "font-size: 12px; color: rgb(5, 5, 5); margin: 0;",
		h4: "",
		h5: "",
		h6: "",
	};

	static override getType() {
		return "inline-heading";
	}

	static override importJSON(
		serializedNode: SerializedHeadingNode
	): HeadingNode {
		return super.importJSON(serializedNode);
	}

	override exportJSON(): SerializedHeadingNode {
		return super.exportJSON();
	}

	static override clone(node: HeadingNode) {
		return new ExtendedHeadingNode(node.__tag, node.__key);
	}

	override createDOM(config: EditorConfig) {
		const dom = super.createDOM(config);
		dom.setAttribute("style", this.styleMap[this.__tag]);

		return dom;
	}
}

export function $createInlineHeadingNode(
	headingTag: HeadingTagType
): HeadingNode {
	return $applyNodeReplacement(new HeadingNode(headingTag));
}

export function $isInlineHeadingNode(
	node: LexicalNode | null | undefined
): node is HeadingNode {
	return node instanceof HeadingNode;
}
